<template>
	<div class="pages">

		<router-link :to="{ name: 'Home' }" tag="span" class="logo">
			<img src="../../../static/images/logo.png" alt="" class="logo-img">
		</router-link>

		<div class="box">
			<div class="box-tit">{{ $t('注册') }}</div>
			<div class="box-box">
				<div class="box-ipt">
					<div class="ipt-tit">{{ $t('手机号') }}</div>
					<div class="ipt-ipt">
						<el-dropdown @command="prefixHandleCommand">
							<span class="el-dropdown-link">
								+{{ prefix }}<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item :command="item.name" v-for="(item, index) in prefix_list"
									:key="index">
									{{ item.name }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<input type="number" :placeholder="$t('请输入您的手机号')" v-model="mobile">
					</div>
				</div>
				<div class="box-ipt">
					<div class="ipt-tit">{{ $t('验证码') }}</div>
					<div class="ipt-ipt">
						<input type="number" :placeholder="$t('请输入您的验证码')" class="ipt-ipt-left" v-model="code">
						<captcha-fetch @onCode="onPhoneCode" ref="phoneCode"></captcha-fetch>
					</div>
				</div>
				<div class="box-ipt">
					<div class="ipt-tit">{{ $t('密码') }}</div>
					<div class="ipt-ipt">
						<input :type="input_type" :placeholder="$t('请输入您的密码')" v-model="password">
						<img src="../../../static/images/icon/icon03.png" alt="" v-if="input_type == 'password'"
							@click="input_type = 'text'">
						<img src="../../../static/images/icon/icon02.png" alt="" v-else
							@click="input_type = 'password'">
					</div>
				</div>
				<div class="box-btn pointer" @click="onRegister">{{ $t('注册') }}</div>
				<div class="justify-center text-14 margin-top-32">
					<router-link :to="{ name: 'Login' }" class="right-txt">
						{{ $t('已有账号，前去') }} <span class="text-61AC85">{{ $t('登录') }}</span>
					</router-link>
				</div>
				<div class="box-read" style="margin-top: 48px;">
					<el-checkbox v-model="is_read">
						<div style="color: #333;">
							{{ $t('我已阅读并同意') }}
							<span class="text-61AC85" @click.stop="onPage(14)">{{ $t('《用户协议》') }}</span>
							{{ $t('与') }}
							<span class="text-61AC85" @click.stop="onPage(13)">{{ $t('《隐私政策》') }}</span>
						</div>
					</el-checkbox>
				</div>
			</div>
		</div>

		<div class="pop" v-if="is_pop">
			<div class="pop-box">
				<div class="pop-box-top">
					<img src="" class="top-img">
					<div class="top-tit">{{ $t('用户协议') }}</div>
					<img src="../../assets/login/icons/icon01.png" class="top-img" style="cursor: pointer;"
						@click="is_pop = false">
				</div>
				<div class="pop-box-txt">
					<div v-html="content" class="detail-html"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FixedBar from '@/components/FixedBar';
import AppFooter from '@/components/AppFooter';
import CaptchaFetch from '@/components/CaptchaFetch';
import { getCode, userRegister, userInfo } from '@/api/login';
import { systemPage, phonePrefix, getconf } from '@/api/user';
import he from 'he';

export default {
	name: 'Register',
	components: {
		'fixed-bar': FixedBar,
		'app-footer': AppFooter,
		'captcha-fetch': CaptchaFetch
	},
	data() {
		return {
			is_pop: false,//弹窗
			input_type: 'password',//输入框type
			is_read: true,//是否勾选用户协议隐私政策
			mobile: '',//手机号
			code: '',//验证码
			password: '',//密码
			content: '',//富文本
			prefix_list: [],//前缀列表
			prefix: '',//前缀
			app_logo: '',//logo
		}
	},
	mounted() {
		this.onPhonePrefix();
		this.onGetconf()
	},
	methods: {
		onGetconf() {
			getconf({ module: 'app' }).then(res => {
				if (res.code == 1) {
					let data = res.data
					this.app_logo = data.app_logo
				}
			})
		},
		/**前缀切换 */
		prefixHandleCommand(e) {
			// console.log(e);
			this.prefix = e
		},
		/**手机号前缀 */
		onPhonePrefix() {
			phonePrefix().then(res => {
				this.prefix_list = res.data
				this.prefix = this.prefix_list[0].name
				console.log(res.data);
			})
		},
		/**注册 */
		onRegister() {
			if (!this.mobile) {
				this.$message(this.$t('请输入手机号'));
				return
			}
			if (!this.code) {
				this.$message(this.$t('请输入验证码'));
				return
			}
			if (!this.password) {
				this.$message(this.$t('请输入密码'));
				return
			}
			if (!this.is_read) {
				this.$message(this.$t('请阅读并同意遵守《用户协议》'));
				return
			}
			let data = {
				mobile: this.mobile,
				password: this.password,
				code: this.code,
				type: 1,
				prefix: this.prefix,
			}
			userRegister(data).then(res => {
				console.log(res);
				if (res.code == 1) {
					this.$cookies.set('user_token', res.data.userinfo.user_token, { expires: 7 }); // 7天后过期
					this.onUserInfo()
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		/**用户信息 */
		onUserInfo() {
			userInfo().then(res => {
				console.log(res);
				if (res.code == 1) {
					this.$message.success(this.$t('注册成功'));
					this.$cookies.set('user_info', JSON.stringify(res.data), { expires: 7 }); // 7天后过期

					setTimeout(() => {
						this.$router.push({ name: 'Home' });
					}, 1000)
				}
			})
		},
		/**获取手机验证码 */
		onPhoneCode() {
			if (!this.mobile) {
				this.$message(this.$t('请输入手机号'));
				return
			}

			let data = {
				mobile: this.mobile,
				type: 1,
				is_test: this.$isDev,
				prefix: this.prefix,
			}

			getCode(data).then(res => {
				console.log(res);
				if (res.code == 1) {
					if (this.$isDev == 1) {
						this.$message.success(this.$t('验证码为：') + res.data.code);
						this.code = res.data.code
					} else {
						this.$message.error(res.data.msg);
					}
					this.$refs.phoneCode.start()
				} else {
					this.$message.error(res.data.msg);
				}
			})
		},
		//1用户协议2隐私政策
		onPage(i) {
			systemPage({ type: i }).then(res => {
				this.content = he.decode(res.data.content)
				this.is_pop = true
				// console.log(this.content);
			})
		},
		//区域选择
		handleCommand(command) {
			// this.$message('click on item ' + command);
			console.log(command);
		}
	}
};
</script>

<style scoped lang="scss">
.pages {
	padding-top: 24px;
	min-height: 100vh;
	height: auto;
	background: url('../../../static/images/bg/bg01.png') no-repeat;
	background-size: cover;
	background-position: center;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-left: 16px;
	padding-right: 16px;
}

.logo {
	display: flex;
	justify-content: center;
	padding-bottom: 40px;

	.logo-img {
		width: 160px;
        height: 85px;
		cursor: pointer;
	}
}

.box {
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #FFFFFF;
	box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
	border-radius: 8px;
	padding: 24px 20px;
	width: 100%;
	max-width: 780px;

	@media (min-width: 768px) {
		padding: 32px 100px;
	}

	.box-tit {
		font-size: 36px;
		color: #333333;
		font-weight: 500;
		margin-bottom: 16px;
	}

	.box-box {
		width: 100%;
		max-width: 580px;

		/**用户协议复选框选中状态统一为黑色 */
		/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
			border-color: #000000;
			background: #000000;
		}

		/**输入框 */
		.box-ipt {
			width: 100%;
			border-bottom: 1px solid #666666;
			margin-top: 24px;

			.ipt-tit {
				font-size: 16px;
			}

			.ipt-ipt {
				padding: 16px 0;
				display: flex;
				align-items: center;
				justify-content: space-between;

				input {
					font-size: 16px;
					width: calc(100% - 50px);
				}

				img {
					width: 24px;
					height: 24px;
					cursor: pointer;
				}

				.ipt-ipt-left {
					width: calc(100% - 150px);
				}
			}
		}

		/**按钮 */
		.box-btn {
			width: 100%;
			height: 56px;
			margin-top: 48px;
			background: #FFFFFF;
			border-radius: 4px;
			border: 1px solid #000000;
			font-size: 20px;
			color: #000000;
			line-height: 56px;
			text-align: center;
		}

		/**用户协议或隐私政策 */
		.box-read {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			color: #333333;
			margin-top: 12px;
			cursor: pointer;

			/**H5 端协议文本与复选框对齐，英文长文案可正常换行 */
			@media (max-width: 767px) {
				justify-content: flex-start;

				/deep/ .el-checkbox {
					display: flex;
					align-items: flex-start;
					text-align: left;
				}

				/deep/ .el-checkbox__input {
					flex-shrink: 0;
					margin-top: 2px;
				}

				/deep/ .el-checkbox__label {
					flex: 1;
					min-width: 0;
					white-space: normal;
					line-height: 20px;
				}
			}
		}
	}
}

/**弹窗 */
.pop {
	width: 100vw;
	height: 100vh;
	background-color: rgba(50, 50, 50, 0.8);
	position: fixed;
	left: 0;
	top: 0;
	z-index: 999;
	display: flex;
	align-items: center;
	justify-content: center;

	.pop-box {
		width: 92vw;
		max-width: 1200px;
		/* // height: 732px; */
		max-height: 732px;
		background: #FFFFFF;
		border-radius: 16px;
		padding-bottom: 32px;

		.pop-box-top {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 90px;
			padding: 0 24px;

			.top-img {
				width: 16px;
				height: 16px;
			}

			.top-tit {
				font-size: 20px;
				font-weight: bold;
				color: #333333;
			}
		}

		.pop-box-txt {
			padding: 0 48px;
			font-size: 16px;
			color: #333333;
			/* // height: 609px; */
			max-height: 610px;
			overflow-y: auto;
			box-sizing: border-box;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/view/login/Register.vue